import trainEvents from '../config/train-events';
import {outOfPolicyStatusStyle} from '../../common/enum/out-of-policy-status-style';

export default function TrainsListBaseController(
    $scope,
    $rootScope,
    $state,
    $q,
    $timeout,
    trainsFactory,
    basketService,
    flightsUtils,
    l10nService,
    flightFareService,
    flightsService
) {
    'ngInject';

        activate();
        initWatchers();

        function activate() {
            const module = trainsFactory.getModule();
            const labels = {
                flights: {
                    showDetails: l10nService.localize('See flight details'),
                    hideDetails: l10nService.localize('Hide flight details'),
                },
                trains: {
                    showDetails: l10nService.localize('See train details'),
                    hideDetails: l10nService.localize('Hide train details'),
                },
            };

            $scope.flightFareService = flightFareService;
            $scope.composeCompanyLogoUrl = flightsService.getFlightSupplierLogo;

            $scope.selectedFlights = {};

            $scope.labels = labels[module];

            $scope.flights = trainsFactory.getFlights();

            if (_.isEmpty($scope.flights)) {
                return $state.go('main.' + trainsFactory.getModule() + '.roundtrip');
            }

            $scope.FareTypeTooltips = {
                Standard: l10nService.localize('These fares are typically the most restrictive'),
                Negotiated: l10nService.localize('A Key Travel special fare which may include flexible conditions'),
                Charity: l10nService.localize('A holdable and flexible fare with minimal airline charges for changes or cancellations'),
            };

            $scope.filterBySegmentModel = angular.copy(trainsFactory.params.SegmentFilterData);

            trainsFactory.resetSegmentFilterData();

            setDefaultSelectedFlightGroup($scope.flights.Recommendations);

            $scope.getArrivalPoint = getArrivalPoint;
            $scope.selectTimeAlternative = selectTimeAlternative;
            $scope.prepareRulesLink = prepareRulesLink;
            $scope.prepareFareBenefits = prepareFareBenefits;
            $scope.hasOperator = hasOperator;
            $scope.printOperator = printOperator;
            $scope.filterBySegment = filterBySegment;
            $scope.outsideOfHoldWindow = outsideOfHoldWindow;
            $scope.inBasket = inBasket;
            $scope.cantBeAddedToBasket = cantBeAddedToBasket;
            $scope.addToBasket = addToBasket;
            $scope.checkSameAirports = flightsUtils.checkSameAirports;
            $scope.checkGroupSameAirports = flightsUtils.checkGroupSameAirports;
            $scope.loadMore = loadMore;
            $scope.isSearchInProcess = false;
            $scope.isArrivalSameAsDeparture = isArrivalSameAsDeparture;
            $scope.getFlightOrTrain = flightsUtils.getFlightOrTrain;
            $scope.getOutOfPolicyStatusStyle = getOutOfPolicyStatusStyle;
        }

        function getArrivalPoint(flight, segmentIndex, selectedFlights, flightIndex) {
            const flightsLastIndex = flight.FlightSegments[segmentIndex].FlightGroups[selectedFlights[flightIndex][segmentIndex]].Flights.length - 1;
            return flight.FlightSegments[segmentIndex].FlightGroups[selectedFlights[flightIndex][segmentIndex]].Flights[flightsLastIndex].ArrivalAirport;
        }

        function initWatchers() {
            $scope.$watch('flights.Recommendations.length', setDefaultSelectedFlightGroupsForNewResults);
            $scope.$on(trainEvents.CLEAR_SEGMENTS, () => $scope.filterBySegmentModel = []);

            $rootScope.$on(trainEvents.FLIGHT_FILTER_SEARCH_STARTED, function() {
                $scope.isSearchInProcess = true;
            });

            $rootScope.$on(trainEvents.FLIGHT_FILTER_SEARCH_ENDED, function() {
                $scope.isSearchInProcess = false;
                $scope.flights = trainsFactory.getFlights();
            });
        }

        function selectTimeAlternative(flightIndex, segmentIndex, flightGroupIndex) {
            // ng-init will init each time alternative with index 0 (selected) as pre-selected
            // then we are changing selected value in "selectedFlights" array
            if (!$scope.selectedFlights[flightIndex]) {
                $scope.selectedFlights[flightIndex] = {};
            }

            $scope.selectedFlights[flightIndex][segmentIndex] = flightGroupIndex;
        }

        function prepareRulesLink(flightIndex, fareIndex) {
            const flight = $scope.flights.Recommendations[flightIndex];
            const flightGroups = $scope.selectedFlights[flightIndex];

            return flightsUtils.prepareRulesLink(flight, fareIndex, flightGroups,
                trainsFactory.params.Travelers, trainsFactory.params.SearchId);
        }

        function filterBySegment(flight) {
            trainsFactory.applySegmentFilterId(flight);
            trainsFactory.filterBySegment()
                .then(({data: {Recommendations, FilteredTotal}}) => {
                    Object.assign($scope.flights, {Recommendations, FilteredTotal});
                    $rootScope.$broadcast(trainEvents.APPLY_FILTERS);
                });
        }

        function hasOperator(segment, selectedFlights, flightIndex, segmentIndex) {
            return trainsFactory.hasOperator(
                segment.FlightGroups[selectedFlights[flightIndex][segmentIndex]].Flights
            );
        }

        function printOperator(segment, selectedFlights, flightIndex, segmentIndex) {
            return trainsFactory.getOperator(
                segment.FlightGroups[selectedFlights[flightIndex][segmentIndex]].Flights
            );
        }

        function prepareFareBenefits(benefits) {
            const result = angular.copy(benefits || {});
            if (!result.hasOwnProperty('BaggageAllowance')) {
                result.BaggageAllowance = 0;
            }
            return result;
        }

        function setDefaultSelectedFlightGroupsForNewResults(currentFlightLength,
                                                             startIndexWithNotSelectedFlightGroups) {
            if (currentFlightLength !== startIndexWithNotSelectedFlightGroups) {
                if (isAfterLoadMoreResults()) {
                    setDefaultSelectedFlightGroup(
                        $scope.flights.Recommendations.slice(startIndexWithNotSelectedFlightGroups),
                        startIndexWithNotSelectedFlightGroups);
                } else {
                    setDefaultSelectedFlightGroup($scope.flights.Recommendations);
                }
            }

            function isAfterLoadMoreResults() {
                return currentFlightLength > startIndexWithNotSelectedFlightGroups;
            }

        }

        function loadMore() {
            trainsFactory.loadMoreFlights();
            $scope.flights = trainsFactory.getFlights();
        }

        function outsideOfHoldWindow(index) {
            return !$scope.flights
                .Recommendations[index]
                .FlightSegments[0]
                .FlightGroups[$scope.selectedFlights[index][0]]
                .CanBeBooked;
        }

        function inBasket(index, fareIndex) {
            const flight = $scope.flights.Recommendations[index];
            const fareId = flight.FareRecommendations[fareIndex].FareRecommendationGuid;
            const flightGroups = $scope.selectedFlights[index];

            return basketService.inBasket('flight', flight, fareId, flightGroups);
        }

        function cantBeAddedToBasket(flightIndex, fareIndex) {
            return $scope.inBasket(flightIndex, fareIndex)
                || $scope.outsideOfHoldWindow(flightIndex)
                || $scope.flights.Recommendations[flightIndex].FareRecommendations[fareIndex].OutOfPolicyStatus === 5;
        }

        function addToBasket(flightIndex, fareIndex) {
            const flight = $scope.flights.Recommendations[flightIndex];
            const fare = flight.FareRecommendations[fareIndex];
            const flightGroups = $scope.selectedFlights[flightIndex];

            const isRoundtrip = trainsFactory.params.flightType === 'roundtrip';
            const searchId = trainsFactory.params.SearchId;

            basketService.addEurostar(flight, fare, flightGroups, trainsFactory.params, searchId, isRoundtrip);
        }

        function setDefaultSelectedFlightGroup(flights, indexOffset) {
            const offset = indexOffset || 0;
            _.forEach(flights, function(flight, flightIndex) {
                _.forEach(flight.FlightSegments, function(segment, segmentIndex) {
                    selectTimeAlternative(flightIndex + offset, segmentIndex, 0);
                });
            });
        }

        function isArrivalSameAsDeparture(flightSegments, segmentIndex, flightIndex, isDepartureBlock) {
            if (!flightsUtils.isSameAirportCheckNeeded(flightSegments, isDepartureBlock, segmentIndex)) {
                return true;
            }

            if (segmentIndex === 0) {
                if (isDepartureBlock) {
                    return getDepartureAirportFromFirstPoint() === getArrivalAirportFromLastPoint();
                }
                    return getArrivalAirportFromFirstPoint() === getDepartureAirportFromLastPoint();

            } else if (isDepartureBlock) {
                    return getArrivalAirportFromFirstPoint() === getDepartureAirportFromLastPoint();
                }
                    return getDepartureAirportFromFirstPoint() === getArrivalAirportFromLastPoint();


            function getArrivalAirportFromFirstPoint() {
                return findLastFlightArrivalPointOfFlightSegmentByIndex(0);
            }

            function getDepartureAirportFromLastPoint() {
                if (flightSegments[1]) {
                    return flightSegments[1].FlightGroups[$scope.selectedFlights[flightIndex][1]].Flights[0].DepartureAirport;
                }
            }

            function getDepartureAirportFromFirstPoint() {
                return flightSegments[0].FlightGroups[$scope.selectedFlights[flightIndex][0]].Flights[0].DepartureAirport;
            }

            function getArrivalAirportFromLastPoint() {
                return findLastFlightArrivalPointOfFlightSegmentByIndex(1);
            }

            function findLastFlightArrivalPointOfFlightSegmentByIndex(index) {
                if (flightSegments[index]) {
                    const lastFlight = getLastFlightFromSegment();
                    return lastFlight.ArrivalAirport;
                }

                function getLastFlightFromSegment() {
                    const groupFlights = flightSegments[index].FlightGroups[$scope.selectedFlights[flightIndex][index]].Flights;
                    return groupFlights[groupFlights.length - 1];
                }
            }
        }

    function getOutOfPolicyStatusStyle(status) {
        return outOfPolicyStatusStyle(status);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-list-base-controller.js